// Shared constants for the Guest Map feature. Extracted from
// `GuestMapPage.js` so the constants can be imported by the extracted
// hooks and subcomponents without pulling the whole page into scope.

// Closest carousel + "All around you" list filter radius (km).
// Also the search-suggestion radius — matches the map so search never
// lies about what's actually available around the guest.
export const NEARBY_RADIUS_KM = 20;

// Layout constants. The mini-map and bottom-nav both shrink together
// when the user scrolls down the venue list, giving back ~38px of
// vertical real estate while remaining tappable.
export const MINI_MAP_HEIGHT = 100;         // shows "Swipe up to open"
export const MINI_MAP_HEIGHT_COMPACT = 58;  // scroll-compact state
export const NAV_HEIGHT = 76;
export const NAV_HEIGHT_COMPACT = 58;
// Covers safe-area-inset-top + greeting + search + chips + location badge.
export const HEADER_HEIGHT = 260;
// Matches the CSS height transition on the fixed map section.
export const MAP_ANIM_MS = 260;
